import React from 'react';
import PropTypes from 'prop-types';
import { ArrowForward } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';


// Main Component
const FindASpaceCard = ({ imageSource, imageAlt, title, description, onClick, hideButton }) => {
 
  const [isHovered, setIsHovered] = React.useState(false);

  return (

    <div id="find-a-space-card" className={isHovered ? 'find-a-space-card-container-hover' : 'find-a-space-card-container'}     
      onMouseOver={() => setIsHovered(true)}
      onFocus={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className='find-a-space-card-icon-and-text-container'>       

          <div className={`find-a-space-card-image-container ${isHovered ? 'find-a-space-card-image-container-bg-hover' : 'find-a-space-card-image-container-bg'} `}>

            <img src={imageSource} alt={imageAlt} className='find-a-space-card-icon-image' />

          </div>      

        <div>
          <h5>{title}</h5>
          <p>{description}</p>
        </div>

      </div>

      {!hideButton && (
        <IconButton onClick={onClick} className={isHovered ? 'find-a-space-card-icon-button-hover' : 'find-a-space-card-icon-button'}>
          <ArrowForward className={isHovered ? 'find-a-space-card-arrow-icon-hover' : 'find-a-space-card-arrow-icon'} />
        </IconButton>
      )}

    </div>
  );
};

FindASpaceCard.propTypes = {
  imageSource: PropTypes.string,
  imageAlt: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  hideButton: PropTypes.bool,
};

export default FindASpaceCard;